import { apiClient } from './client';
import type { ApiResponse } from '@/types/api.types';

export interface AdminTenant {
  id: string;
  name: string;
  slug: string;
  status: 'active' | 'suspended' | 'trial';
  userCount: number;
  createdAt: string;
  updatedAt: string;
}

export interface CreateTenantInput {
  name: string;
  slug: string;
  ownerName: string;
  ownerEmail: string;
  ownerPassword: string;
}

export interface AdminTenantUser {
  id: string;
  name: string;
  email: string;
  role: string;
}

export interface AdminUplogStats {
  tenantId: string;
  tenantName: string;
  today: number;
  thisMonth: number;
  failedMonth: number;
  pending: number;
  vencidos: number;
}

export const adminApi = {
  listTenants: () => apiClient.get<ApiResponse<AdminTenant[]>>('/admin/tenants'),

  createTenant: (data: CreateTenantInput) =>
    apiClient.post<ApiResponse<{ tenant: AdminTenant }>>('/admin/tenants', data),

  updateTenantStatus: (id: string, status: AdminTenant['status']) =>
    apiClient.patch<ApiResponse<AdminTenant>>(`/admin/tenants/${id}/status`, { status }),

  deleteTenant: (id: string) => apiClient.delete(`/admin/tenants/${id}`),

  listTenantModules: (id: string) =>
    apiClient.get<{ data: string[] }>(`/admin/tenants/${id}/modules`),

  setTenantModule: (id: string, module: string, enabled: boolean) =>
    apiClient.patch(`/admin/tenants/${id}/modules/${module}`, { enabled }),

  listTenantUsers: (id: string) =>
    apiClient.get<ApiResponse<AdminTenantUser[]>>(`/admin/tenants/${id}/users`),

  resetTenantUserPassword: (id: string, userId: string, password: string) =>
    apiClient.patch<ApiResponse<{ success: boolean }>>(
      `/admin/tenants/${id}/users/${userId}/password`,
      { password },
    ),

  getAdminUplogStats: () => apiClient.get<ApiResponse<AdminUplogStats[]>>('/admin/uplog-stats'),
};
